// extracted by mini-css-extract-plugin
export default {"input":"InputShallow__input--2rk"};